import { RequestType } from 'common/constants/app.constant';

export class BaseDataModel {
    id: string | number = 0;
}

export class ResponseAndErrorModel {
    data: any[] = [];
    error: any[] = [];
    constructor(data: any, error: any) {
        this.data = data;
        this.error = error;
    }
}

export class NavDataHistory {
    pageMeta: BaseMetaModel;
    componentData: any;
    pageData: BaseDataModel;
    queryParams?: any;
}

export class RouteMessage {
    type: RequestType;
    transferData: any = {};
}

export class RouteDetails {
    url: string;
    message: RouteMessage;
}

export class ResponseType<T> {
    data: T;
    meta: any;
    componentData: any;
    queryParams?: any;
}

export class ComponentData {
    isFormRender?: boolean;
    actionType?: string;
    routeData: any;
}

export class BaseMetaModel {
    pageTitle: string;
    redirectPath: string;
    properties: any;
    isFormRender: boolean;
    headerButtonPath: string;
}

export abstract class BHMetaModel extends BaseMetaModel {
    properties: any;
    constructor(title: string, redirectPath: string, isFormRender: boolean = false, headerButtonPath: string) {
        super();
        this.pageTitle = title;
        this.redirectPath = redirectPath;
        this.isFormRender = isFormRender;
        this.headerButtonPath = headerButtonPath;
    }

    abstract getMetaModel(): BaseMetaModel;
    abstract initProperties(): any;
}

export abstract class FormMetaModel extends BHMetaModel {
    [x: string]: any;
    constructor(protected pageName: string, public redirectPath: string, public isFormRender: boolean = false, headerButtonPath: string) {
        super(pageName, redirectPath, isFormRender, headerButtonPath);
    }

    getMetaModel(): BaseMetaModel {
        const pageInfo = new BaseMetaModel();
        pageInfo.pageTitle = this.pageTitle;
        pageInfo.isFormRender = this.isFormRender;
        pageInfo.properties = this.initProperties();
        pageInfo.redirectPath = this.redirectPath;
        pageInfo.headerButtonPath = this.headerButtonPath;
        return pageInfo;
    }
}

export abstract class BHUIModel {
    constructor(
        protected id: string = '',
        protected fieldName: string = '',
        protected required: boolean = false,
        protected label: string = '',
        protected type: 'number' | 'text' | 'textarea' | 'currency' | 'email' | 'password' | 'select' | 'file' | 'url' | 'radio' | 'date' | 'charactersonly' | 'charandnumber' = 'text',
        protected placeholder: string = '',
        protected maxlength: number = 0,
        protected minlength: number = 0,
        protected readOnly: boolean = false,
        protected isRequiredFormValidation: boolean = true
    ) { }
}

export class BHMetaInputModel extends BHUIModel {
    constructor(
        protected id: string = '',
        protected fieldName: string = '',
        protected required: boolean = false,
        protected label: string = '',
        protected type: 'number' | 'text' | 'textarea' | 'currency' | 'email' | 'password' | 'select' | 'file' | 'url' | 'radio' | 'date' | 'charactersonly' | 'charandnumber' = 'text',
        protected placeholder: string = '',
        protected maxlength: number = 0,
        protected minlength: number = 0,
        protected readOnly: boolean = false,
        protected isRequiredFormValidation: boolean = true,
        protected pattern: string = '',
        protected showCharacterCount: boolean = false
    ) {
        super(id, fieldName, required, label, type, placeholder, maxlength, minlength, readOnly, isRequiredFormValidation);
    }
}

export class BHBtnMetaModel extends BHUIModel {
    constructor(protected theme: 'light' | 'dark', protected label: string) {
        super();
    }
}

export class BHMetaSelectModel extends BHUIModel {
    optionsValueField: any[] = [];
    bindLabelField: string;
    bindValueField: string;
    isMultiSelectField: boolean;

    constructor(
        protected id: string = '',
        protected fieldName: string = '',
        protected required: boolean = false,
        protected label: string = '',
        protected type: 'number' | 'text' | 'textarea' | 'currency' | 'email' | 'password' | 'select' | 'file' = 'text',
        protected placeholder: string = '',
        protected options: any[] = [],
        protected bindLabel: string,
        protected bindValue: string,
        protected isMultiSelect: boolean
    ) {
        super(id, fieldName, required, label, type, placeholder);
        this.getProperties();
    }

    getProperties(): void {
        this.optionsValueField = this.options;
        this.bindLabel = this.bindLabel;
        this.bindValue = this.bindValue;
        this.isMultiSelectField = this.isMultiSelect;
    }
}

export class BHMetaFileModel extends BHUIModel {
    constructor(
        protected id: string = '',
        public fieldName: string = '',
        public required: boolean = false,
        public label: string = '',
        public fType: string[] = [],
        public maxSize: string = '',
        public allowMultiple: boolean = false,
        public maxheight: number = 0,
        public maxWidth: number = 0,
        public allowFileChooser = false
    ) {
        super(id, fieldName, required, label);
    }
}

export class BHMetaCalenderModel extends BHUIModel {
    error: string = '';
    disabled: boolean = false;
    dayValues: [];
    minDate: any = '';
    maxDate: any = '';
    constructor(protected id: string = '', public fieldName: string = '', public required: boolean = false, public label: string = '', public errorMessage: string, disabled: boolean, dayValues: [], minDate: any = '', maxDate: any = '', placeholder: any = '') {
        super(id, fieldName, required, label);
        this.error = errorMessage;
        this.disabled = disabled;
        this.dayValues = dayValues;
        this.minDate = minDate;
        this.maxDate = maxDate;
        this.placeholder = placeholder;
    }
}

export class BHInputSelectModel extends BHUIModel {
    ischecekd: boolean;

    constructor(protected id: string = '', public fieldName: string = '', public required: boolean = false, public label: string = '', public isChekecked: boolean = false) {
        super(id, fieldName, required, label);
        this.isChekecked = isChekecked;
    }
}

// For Opportunity List
export class HeaderList {
    name: string;
    logo: string;
}
